import { useMemo } from "react";
import i18next from "i18next";
import { EU_EXPERIMENT_MAP, EXPERIMENT_MAP } from "../constant";

// Applicable discount on sign up for exclusive email.
const SIGN_UP_DISCOUNT_LOCALES = new Map<string, number>([
  ["en-GB", 10],
  ["en-IE", 10],
  ["pt-PT", 10],
  ["it-IT", 5],
  ["es-ES", 5],
  ["en-CA", 15],
  ["fr-CA", 15],
  ["en-US", 15],
  ["es-US", 15],
  ["fr-FR", 15],
  ["de-DE", 10],
  ["de-AT", 10],
  ["de-CH", 10],
  ["fr-CH", 10],
  ["it-CH", 10],
  ["nl-BE", 5],
  ["fr-BE", 5],
  ["nl-NL", 5],
  ["sv-SE", 10],
  ["da-DK", 10],
  ["nb-NO", 10],
  ["fi-FI", 10]
]);
const cultureMap = new Map<string, string[]>([
  ["vistaprint", ["en-IN", "en-AU", "en-NZ", "en-US", "es-US", "en-CA", "fr-CA", "es-ES", "en-GB", "de-CH", "fr-CH", "it-CH"]],
  // ["vistacreate", ["en-FR", "fr-FR", "uk-UA", "en-IE", "en-AT", "de-AT", "en-CH", "de-CH", "fr-CH", "it-CH", "en-BE", "fr-BE", "nl-BE", "nl-NL", "fi-FI", "sv-SE", "en-NO", "nb-NO", "en-ES", "es-ES", "en-IT", "it-IT", "en-PT", "pt-PT"] ],
  ["vistacreate", ["en-US", "es-US", "en-CA", "fr-CA", "en-AU", "en-NZ", "en-SG", "en-IN", "en-BR", "pt-BR", "en-CO", "es-CO", "en-MX", "es-MX", "uk-UA", "tr-TR"]],
  ["99designs", []]
]);

const DISABLE_OPT_INS = ["da-DK", "sv-SE", "en-IE", "en-GB", "nb-NO", "fi-FI"];

export type AuthenticationCustomization = {
  isAutomaticAgreementEnabled: boolean;
  isEligibleForSignUpDiscounts: boolean;
  applicableDiscountOnSignUp: number | undefined;
  isOptInDisabled: boolean;
};

export default function useCustomization (site: string): AuthenticationCustomization {
  const isAutomaticAgreementEnabled = useMemo(() => {
    const startPeriodTime = new Date("August 29, 2024 08:00:00 UTC");
    const endPeriodTime = new Date("October 7, 2024 13:59:59 UTC");
    const startPeriodTestTime = new Date("January 25, 2024 06:00:00 UTC");
    const endPeriodTestTime = new Date("January 25, 2024 06:20:00 UTC");
    const currentDate = new Date(new Date().toUTCString());
    const isExperimentWindowPeriod = ((startPeriodTime <= currentDate && currentDate <= endPeriodTime) || (startPeriodTestTime <= currentDate && currentDate <= endPeriodTestTime)) && currentDate.getUTCMinutes() < 30;
    return (cultureMap.get(site.toLowerCase()) || []).includes(i18next.language) ||
    (((EXPERIMENT_MAP.get(site.toLowerCase()) || []).includes(i18next.language) || (EU_EXPERIMENT_MAP.get(site.toLowerCase()) || []).includes(i18next.language)) && isExperimentWindowPeriod);
  }, [site]);
  const isEligibleForSignUpDiscounts = useMemo(() => {
    return Array.from(SIGN_UP_DISCOUNT_LOCALES.keys()).includes(
      i18next.language
    );
  }, []);

  const applicableDiscountOnSignUp = useMemo(() => {
    return SIGN_UP_DISCOUNT_LOCALES.get(i18next.language);
  }, []);

  const isOptInDisabled = useMemo(() => {
    return DISABLE_OPT_INS.includes(i18next.language);
  }, []);

  return {
    isAutomaticAgreementEnabled,
    isEligibleForSignUpDiscounts,
    applicableDiscountOnSignUp,
    isOptInDisabled
  };
}
